import { render } from "./productBasalamSetting.vue?vue&type=template&id=dc7f4ed6"
import script from "./productBasalamSetting.vue?vue&type=script&lang=js"
export * from "./productBasalamSetting.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/medicalmobile-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__